import TransferMainPage from "./main.container";

export default TransferMainPage;
